const IDLE_FALLBACK_MS = 1000

export const pageModules = {
	home: () => import('./pages/Home'),
	tasks: () => import('./pages/Tasks'),
	taskPage: () => import('./pages/TaskPage'),
	settings: () => import('./pages/Settings'),
	handbook: () => import('./pages/handbook/Handbook'),
	handbookDocument: () => import('./pages/handbook/Document'),
	handbookProposals: () => import('./pages/handbook/Proposals'),
	financeOverview: () => import('./pages/finance/Overview'),
	financeSales: () => import('./pages/finance/Sales'),
	financeEvents: () => import('./pages/finance/Events'),
	transactions: () => import('./pages/finance/Transactions'),
	invoices: () => import('./pages/finance/Invoices'),
	profile: () => import('./pages/Profile'),
	navSettings: () => import('./pages/NavSettings'),
	team: () => import('./pages/staff/Team'),
	users: () => import('./pages/staff/Users'),
	hiring: () => import('./pages/staff/Hiring'),
	applicant: () => import('./pages/staff/Applicant'),
	applicantReview: () => import('./pages/staff/Review'),
	operationsEntry: () => import('./pages/operations/OperationsEntry'),
	onTap: () => import('./pages/operations/OnTap'),
	quality: () => import('./pages/operations/Quality'),
	recipes: () => import('./pages/operations/Recipes'),
	kegRecipe: () => import('./pages/operations/KegRecipe'),
	prepRecipe: () => import('./pages/operations/PrepRecipe'),
	closing: () => import('./pages/operations/Closing'),
	shopping: () => import('./pages/operations/Shopping'),
	schedule: () => import('./pages/schedule/Schedule'),
	availability: () => import('./pages/schedule/Availability'),
	shiftTemplates: () => import('./pages/schedule/Templates'),
	timesheets: () => import('./pages/schedule/Timesheets'),
	vouchers: () => import('./pages/Vouchers'),
	leads: () => import('./pages/Leads'),
}

function preloadAll(): void {
	for (const load of Object.values(pageModules)) void load().catch(() => undefined)
}

export function preloadPagesWhenIdle(): () => void {
	if (typeof window.requestIdleCallback === 'function') {
		const handle = window.requestIdleCallback(preloadAll)
		return () => window.cancelIdleCallback(handle)
	}
	const timer = window.setTimeout(preloadAll, IDLE_FALLBACK_MS)
	return () => window.clearTimeout(timer)
}
